<template>
  <div>
    <ServicesTopBar />
    <Banner title="About Us"/>
    <section class="page_detail_section">
      <div class="container">
        <b-card class="details-page-box">
          <blockquote class="blockquote mb-0">
            <div class="terms_content_view" v-html="contents.content"/>
          </blockquote>
        </b-card>
      </div>
    </section>
    <SiteFooter />
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import Banner from '../components/page/Banner.vue'
import PageDetails from '../components/page/PageDetails.vue'
import ServicesTopBar from '../components/services/ServicesTopBar.vue'
import SiteFooter from '../components/site/SiteFooter.vue'

export default {
  components: {
    ServicesTopBar, SiteFooter, Banner, PageDetails, BCard,
  },
  data() {
    return {

    }
  },
  computed: {
    contents() {
      return this.$store.state.page_content.page_contents
    },
  },
  mounted() {
    this.getContent()
  },
  methods: {
    getImage(image) {
      return `background: url(${image})`
    },
    getContent() {
      return this.$store.dispatch('page_content/getAllContent', 'about-us')
    },
  },
}
</script>

<style scoped>

</style>
